import React, { Component } from 'react'
import moment from 'moment'
import { Collapse, Icon, Button } from 'antd'
import ContactsCollapse from './Collapse'

const { Panel } = Collapse

class Jobs extends Component {
  renderElement = job => {
    const { handleRowJobClick } = this.props
    const { id, name, type, created_date } = job
    const createdDate = moment.utc(created_date).format('M/D/YYYY')
    return (
      <Panel key={id} header={name}>
        <div className="row">
          <div className="col-md-5">
            <div className="jobDetailsHeader">Name:</div>
            <span>{name}</span>
          </div>
          <div className="col-md-3">
            <div className="jobDetailsHeader">Type:</div>
            <span>{type}</span>
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Created:</div>
            <span>{createdDate}</span>
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Edit:</div>
            <Button onClick={() => handleRowJobClick(job)}>
              <Icon type="edit" />
            </Button>
          </div>
        </div>
      </Panel>
    )
  }
  render() {
    const contactJobs = this.props.contactJobs || []
    return (
      <div>
        <div className="row">
          <div className="col-md-6">
            <h4>Jobs</h4>
          </div>
        </div>
        <ContactsCollapse emptyText="There are no jobs for this contact">
          {contactJobs.map(this.renderElement)}
        </ContactsCollapse>
      </div>
    )
  }
}

export default Jobs



// WEBPACK FOOTER //
// ./src/components/contacts/Jobs.js